<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col :class="readonly ? 'readonly-form' : ''">
        <card-page
            :card-title="cardTitle"
            :switch-model="model.IsEnabled"
        >
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
              ref="form"
              :model="model"
              :options="formOptions"
              :schema="schema"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import CardPage from '../../components/Views/CardPage';

const selectOptions = {
  showLabels: false,
  key: 'id',
  trackBy: 'id',
  label: 'name',
};

export default {
  name: 'ProductForm',
  components: {
    CardPage,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    cardTitle: {
      type: String,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  mixins: [FormModelMixin],
  data() {
    return {
      selectedReferences: [],
      model: {
        CommercialProductSource_FK: null,
        CommercialProductTarget_FK: null,
        Company_FK: null,
      },
      schema: {
        groups: [
          {
            legend: 'General',
            styleClasses: 'w-full',
            fields: [
              {
                disabled: () => this.readonly,
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: 'w-1/3',
                label: "Source Product",
                model: "CommercialProductSource_FK",
                values: () => this.commercialProductsSourceOptions,
                required: true,
                validator: ['required'],
                selectOptions: {
                  showLabels: false,
                  hideSelected: true,
                  key: "id",
                  trackBy: "id",
                  label: "name",
                },
              },
              {
                disabled: () => this.readonly,
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: 'w-1/3',
                label: "Target Product",
                model: "CommercialProductTarget_FK",
                values: () => this.commercialProductsTargetOptions,
                required: true,
                validator: ['required'],
                selectOptions: {
                  showLabels: false,
                  hideSelected: true,
                  key: "id",
                  trackBy: "id",
                  label: "name",
                },
              },
              {
                disabled: () => this.readonly,
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Associated Company',
                model: 'Company_FK',
                values: () => this.asyncCompanyOptions,
                placeholder: "Type to search",
                selectOptions: {
                  ...selectOptions,

                  // Async Search
                  hideSelected: false,
                  searchable: true,
                  localSearch: false,
                  internalSearch: false,
                  clearOnSelect: false,
                  onSearch: function(searchQuery, id, options) {
                    if (searchQuery.length === 0) {
                      this.asyncCompanyOptions = []
                    } else {
                      this.asyncCompanyOptions = this.companyOptions.filter((element, index, array) => {
                        return element.name.toLowerCase().includes(searchQuery.toLowerCase())
                      })
                    }
                  }.bind(this),
                },
              },
            ]
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      asyncCompanyOptions: [],
      companyOptions: [],
      commercialProductsSourceOptions: [],
      commercialProductsTargetOptions: [],
      formReferences: [
        'form',
      ],
      options: [
        {
          endpoint: () => this.$api.commercialProducts.list(),
          optionsFieldName: "commercialProductsSourceOptions",
          nameFieldName: "CommercialProductName",
          idFieldName: 'CommercialProductSource_FK',
        },
        {
          endpoint: () => this.$api.commercialProducts.list(),
          optionsFieldName: "commercialProductsTargetOptions",
          nameFieldName: "CommercialProductName",
          idFieldName: 'CommercialProductTarget_FK',
        },
        {
          endpoint: () => this.$api.companies.all(),
          optionsFieldName: 'companyOptions',
          nameFieldName: 'name',
          idFieldName: 'Company_FK',
        },
      ]
    };
  },
};
</script>
